import { CSSObject } from "@emotion/react";
import { mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery: breakpoints } = mediaQueryStyles;

export const imageWrapperStyles: CSSObject = {
  position: "relative",
  "z-index": 1,
};

export const imageWrapperWithTranslateStyles: CSSObject = {
  position: "relative",
  "z-index": 1,
  [breakpoints.upTo("sm")]: {
    paddingInlineStart: "40px",
  },
};
